import { lazy } from 'react';

export const CurrentLicensePage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/CurrentLicensePage').then((m) => ({
    default: m.CurrentLicensePage,
  }))
);

// TenantAdministration (Admin)
export const TenantAdministrationDashboard = lazy(() =>
  import('@/platform/tenant-administration/pages/tenant-administration/TenantAdministrationDashboard').then(
    (m) => ({ default: m.TenantAdministrationDashboard })
  )
);

export const TenantList = lazy(() =>
  import('@/platform/tenant-administration/pages/tenant-administration/TenantList').then((m) => ({
    default: m.TenantList,
  }))
);

export const BillingSuccess = lazy(() =>
  import('@/platform/tenant-administration/pages/tenant-administration/BillingSuccess').then(
    (m) => ({ default: m.BillingSuccess })
  )
);

export const BillingCancel = lazy(() =>
  import('@/platform/tenant-administration/pages/tenant-administration/BillingCancel').then(
    (m) => ({ default: m.BillingCancel })
  )
);

// Platform Admin Pages
export const PlatformDashboardPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/PlatformDashboard').then((m) => ({
    default: m.PlatformDashboard,
  }))
);

export const MSPTenantList = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/MSPTenantList').then((m) => ({
    default: m.MSPTenantList,
  }))
);

export const MSPTenantDetail = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/MSPTenantDetail').then((m) => ({
    default: m.MSPTenantDetail,
  }))
);

export const PlatformLicensingPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/LicensingPage').then((m) => ({
    default: m.LicensingPage,
  }))
);

export const PlatformAPIKeysPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/APIKeysPage').then((m) => ({
    default: m.APIKeysPage,
  }))
);

export const PlatformBillingPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/BillingPage').then((m) => ({
    default: m.BillingPage,
  }))
);

export const PlatformHealthPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/PlatformHealthPage').then((m) => ({
    default: m.PlatformHealthPage,
  }))
);

export const M365AppPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/M365AppPage').then((m) => ({
    default: m.M365AppPage,
  }))
);

export const FeatureFlagsPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/FeatureFlagsPage').then((m) => ({
    default: m.FeatureFlagsPage,
  }))
);

export const PlatformAuditPage = lazy(() =>
  import('@/platform/tenant-administration/pages/platform/PlatformAuditPage').then((m) => ({
    default: m.PlatformAuditPage,
  }))
);
